export interface BrandMarkProps {
  size?: number;
  className?: string;
}

export function BrandMark({ size = 16, className }: BrandMarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className={className}>
      <defs>
        <linearGradient id="brand-blue" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#5FBCED" />
          <stop offset="100%" stopColor="#0C6B99" />
        </linearGradient>
      </defs>
      <text
        x="16"
        y="22"
        textAnchor="middle"
        fontFamily="Georgia, serif"
        fontWeight="700"
        fontStyle="italic"
        fontSize="22"
        fill="url(#brand-blue)"
      >
        S
      </text>
    </svg>
  );
}
